module.exports = __webpack_public_path__ + "static/img/manutencao.7b4f3c3d.png";